import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconTimeFill.tsx
const IconTimeFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.667 16c0 7.364 5.969 13.333 13.333 13.333S29.333 23.364 29.333 16 23.364 2.667 16 2.667 2.667 8.636 2.667 16m20 0h-5.334V9.333h-2.666v9.334h8z",
		clipRule: "evenodd"
	})]
});
var IconTimeFill_default = forwardRef(IconTimeFill);
//#endregion
export { IconTimeFill_default as default };
